import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class InformationService {
  constructor(public http: HttpClient) {}

  GetMakeInfo() {
    return this.http.get(`${environment.api}/settings/information/get/make`);
  }

  GetModelYearInfo(data: object) {
    return this.http.post(
      `${environment.api}/filters/information/get/model-year`,
      data
    );
  }

  GetModelInfo(data: object) {
    return this.http.post(
      `${environment.api}/filters/information/get/model`,
      data
    );
  }

  GetEngineInfo() {
    return this.http.get(
      `${environment.api}/settings/information/get/engine-type`
    );
  }

  GetVendorInfo() {
    return this.http.get(`${environment.api}/settings/information/get/vendor`);
  }

  GetCcInfo() {
    return this.http.get(`${environment.api}/settings/information/get/cc`);
  }

  GetEstimaraInfo() {
    return this.http.get(
      `${environment.api}/settings/information/get/estimara`
    );
  }

  GetVehicleInfo() {
    return this.http.get(
      `${environment.api}/settings/information/get/vehicle-type`
    );
  }

  GetTransmissionInfo() {
    return this.http.get(
      `${environment.api}/settings/information/get/transmission`
    );
  }

  GetBodyInfo() {
    return this.http.get(
      `${environment.api}/settings/information/get/body-type`
    );
  }

  GetDriveInfo() {
    return this.http.get(`${environment.api}/settings/information/get/drive`);
  }

  GetWarrantyInfo() {
    return this.http.get(
      `${environment.api}/settings/information/get/warranty`
    );
  }

  GetExteriorColourInfo() {
    return this.http.get(
      `${environment.api}/settings/information/get/exterior-color`
    );
  }

  GetInteriorColourInfo() {
    return this.http.get(
      `${environment.api}/settings/information/get/interior-color`
    );
  }

  GetUtilityInfo() {
    return this.http.get(
      `${environment.api}/settings/information/get/utility-type`
    );
  }

  GetGearInfo() {
    return this.http.get(`${environment.api}/settings/information/get/gears`);
  }

  GetDoorsInfo() {
    return this.http.get(`${environment.api}/settings/information/get/doors`);
  }

  GetCODInfo() {
    return this.http.get(`${environment.api}/settings/information/get/COD`);
  }

  GetAssessmentInfo() {
    return this.http.get(
      `${environment.api}/settings/information/get/assesment-type`
    );
  }

  GetTrimInfo(data: object) {
    return this.http.post(
      `${environment.api}/filters/information/get/model-trims`,
      data
    );
  }

  GetWheelBase() {
    return this.http.get(`${environment.api}/settings/vehicle-wheel-base`);
  }

  GetCyllinders() {
    return this.http.get(
      `${environment.api}/settings/information/get/cylinders`
    );
  }

  GetCondition() {
    return this.http.get(`${environment.api}/settings/conditions`);
  }

  GetFuelType() {
    return this.http.get(
      `${environment.api}/settings/information/get/fuel-type`
    );
  }

  GetHP() {
    return this.http.get(
      `${environment.api}/settings/information/get/horse-power`
    );
  }

  GetSeats() {
    return this.http.get(
      `${environment.api}/settings/information/get/vehicle-seats`
    );
  }

  GetUphoistry() {
    return this.http.get(
      `${environment.api}/settings/information/get/uphoistery`
    );
  }

  GetService() {
    return this.http.get(`${environment.api}/settings/services`);
  }

  GetOrigin() {
    return this.http.get(`${environment.api}/settings/information/get/origin`);
  }

  GetOwnership() {
    return this.http.get(
      `${environment.api}/settings/information/get/ownership`
    );
  }

  GetMortgage() {
    return this.http.get(`${environment.api}/settings/information/get/mortage`);
  }

  GetMileage() {
    return this.http.get(
      `${environment.api}/settings/information/get/mileage-info`
    );
  }

  GetMaxSpeed() {
    return this.http.get(
      `${environment.api}/settings/information/get/max-speeds`
    );
  }

  GetTorque() {
    return this.http.get(`${environment.api}/settings/information/get/torque`);
  }

  GetAcceleration() {
    return this.http.get(
      `${environment.api}/settings/information/get/acceleration`
    );
  }

  SaveInformation(formObj: any) {
    return this.http.post(
      `${environment.api}/car/add/vin-information`,
      formObj
    );
  }

  getMarketAcceptability() {
    return this.http.get(`${environment.api}/settings/information/get/market-acceptibility`);
  }

  getVehicleStatus(payload: object){
    return this.http.post(`${environment.api}/car/get/vehicle-status`, payload)
  }

}
